// Google Consent Mode v2 bridge.
// Europe: analytics follows the stored choice. The banner already existed;
// this file used to grant analytics anyway, so GA still fired. Non-Europe
// stays granted so we do not change the existing US/rest behavior.

import { isEuropeVisitor } from '@/lib/europeVisitor';

type BannerPrefs = {
  essential?: boolean;
  functional?: boolean;
  analytics?: boolean;
  marketing?: boolean;
  doNotSell?: boolean;
};

export function pushConsentUpdate(prefs: BannerPrefs): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  const europe = isEuropeVisitor();
  const analyticsAllowed = europe ? !!prefs.analytics : true;
  // Ads remain user-controlled (legal requirement for CCPA "Do Not Sell").
  const adsAllowed = !!prefs.marketing && !prefs.doNotSell;

  try {
    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      functionality_storage: europe ? (!!prefs.functional ? 'granted' : 'denied') : 'granted',
      personalization_storage: europe ? (!!prefs.functional ? 'granted' : 'denied') : 'granted',
      security_storage: 'granted',
      ad_storage: adsAllowed ? 'granted' : 'denied',
      ad_user_data: adsAllowed ? 'granted' : 'denied',
      ad_personalization: adsAllowed ? 'granted' : 'denied',
    });
  } catch (err) {
    console.warn('Consent Mode update failed:', err);
  }
}

/**
 * Replays the stored consent choice on app boot.
 * Europe honors analytics; everywhere else analytics stays granted.
 */
export function replayStoredConsent(): void {
  if (typeof window === 'undefined') return;
  try {
    const raw = localStorage.getItem('cookie-consent');
    if (!raw) return;
    const stored = JSON.parse(raw) as BannerPrefs;
    pushConsentUpdate(stored);
  } catch {
    // Ignore malformed storage.
  }
}
